import graphqlClient from "../../../apollo";

class EficienciaProvider {

    eficienciaAgencia(mes, reporteStock) {
        return graphqlClient.query({
            query: require('./gql/Eficiencia/eficienciaAgencia.graphql'),
            fetchPolicy: "network-only",
            variables: {mes, reporteStock}
        })
    }

    obtenerComprasDeAgenciasSeleccionadas(agencias) {
        return graphqlClient.query({
            query: require('./gql/Eficiencia/comprasDeAgencias.graphql'),
            fetchPolicy: "network-only",
            variables: {agencias}
        })
    }

}

export default new EficienciaProvider()


